import { observer } from "mobx-react";
import {
  LocalizedMarkdownQuestion,
  LocalizedTextQuestion,
  NumberQuestion,
} from "@/dbot/common/commonComponents";
import { InsertCompanyBoardInArticlesOfAssociationForm } from "./insertCompanyBoardInArticlesOfAssociationDomain";
import { Alert } from "@/components-v2/Alert";
import { Box, VBox } from "@/components-v2/Box";
import { useEffect } from "react";

import { useTranslation } from "@/stores/RootStoreContext";

export const InsertCompanyBoardInArticlesOfAssociationView = observer(
  function InsertCompanyBoardInArticlesOfAssociationView({
    form,
  }: {
    form: InsertCompanyBoardInArticlesOfAssociationForm;
  }) {
    const { t } = useTranslation();

    useEffect(() => {
      form.languages.forEach((l) => {
        const title = form.titles.find((t) => t.locale === l);
        if (title && !title.model.validatedValue) {
          title.model.setAndCommitInputValue(
            t("decisions.companyBoard.insert-paragraph.defaultTitle", { lang: l }),
          );
        }
      });
    }, [form, t]);

    return (
      <VBox gap={"md"}>
        <NumberQuestion
          question={t("decisions.companyBoard.insert-paragraph.what-paragraph.title")}
          field={form.paragraph}
          isLocked={form.isProjectLocked}
        />
        <Box>
          <Alert
            type="info"
            message={t("decisions.companyBoard.insert-paragraph.what-paragraph.helperText")}
          />
        </Box>
        <LocalizedTextQuestion
          name={"article-titles"}
          question={t("decisions.companyBoard.insert-paragraph.title")}
          textModels={form.titles}
          isLocked={form.isProjectLocked}
        />
        <LocalizedMarkdownQuestion
          name={"article-texts"}
          question={t("decisions.companyBoard.insert-paragraph.text")}
          textModels={form.texts}
          isLocked={form.isProjectLocked}
        />
      </VBox>
    );
  },
);
